import { omit } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import AvatarImage from '../avatar-image';
import resolveUserImage from '../../services/resolve-user-image';

const UserAvatarImage = ({ user = {}, ...props }) =>
  <AvatarImage image={resolveUserImage(user.image)} user={user} {...omit(props, 'dispatch')}/>;

hoistNonReactStatics(UserAvatarImage, AvatarImage);

UserAvatarImage.propTypes = {
  className: PropTypes.string,
  user: PropTypes.object.isRequired,
  type: PropTypes.string,
};

export default UserAvatarImage;



// WEBPACK FOOTER //
// ./app/components/user-avatar-image/user-avatar-image.js